import NacimientoView from "./NacimientoView";
export default NacimientoView;